import React, { useEffect, useMemo, useState } from 'react';
import { unionFlag, getSessonStorage, checkUnifyShop } from '@/utils';
import { withRouter } from 'umi';
import { connect } from 'dva';
import styles from './index.less';
import { TLang } from '@/utils/lang';
const DFfudouImg = require('@/assets/imgs/fudou.png');

/**
 *
 * @param props {iconCls,iconStyles, textStyles}
 */

const DFPrice = (props: any) => {
  const {
    price,
    showIcon = true,
    showQi = false,
    showUnit = false,
    unionConfig,
    iconCls,
    iconStyles,
    textStyles,
    children,
    lineThroungh = false
  } = props;
  // console.log('DFPrice',props)
  const [icon, setIcon] = useState('');
  const unionCode = unionFlag() || getSessonStorage('dffl_union');
  const [union] = useState(unionCode && typeof unionCode !== 'undefined');
  // 获取 union
  useEffect(() => {
    if ((union||checkUnifyShop()) && unionConfig.union_icon) {
      // 取 union icon
      setIcon(unionConfig.union_icon);
    } else {
      setIcon(DFfudouImg);
    }
  }, []);
  const getPrice = (): string => {
    if (union) {
      // price
      let p = (price / 100) * unionConfig.union_scale;
      return p.toFixed(2);
    } else {
      let p = price / 100;
      return p.toFixed(2);
    }
  };
  const getPriceUnit = (): string => {
    if (union||checkUnifyShop()) {
      // price
      return unionConfig.union_name || TLang('福豆', 'home', false, false, null);
    } else {
      return  TLang('福豆', 'home', false, false, null);
    }
  };
  return (
    <div className={`${styles.priceContainer} ${lineThroungh ? styles.priceContainerLinethrough : ''}`}>
      {showIcon ? (
        <img src={icon} className={`${iconCls ? `fd-${iconCls}` : styles.lg} ${lineThroungh ? styles.underline : ''}`} style={iconStyles} />
      ) : null}
      <div className={styles.price} style={textStyles}>
        {getPrice()}
      </div>
      {showUnit ? <span className={styles.unit}>{getPriceUnit()}</span> : null}
      {showQi ? <span className={styles.priceStart}>{TLang('起', 'home', false, false, null)}</span> : null}
      {children}
    </div>
  );
};
const mapStateToProps = ({ initData }) => ({ unionConfig: initData.unionConfig });
export default withRouter(connect(mapStateToProps)(DFPrice));
